export enum GridState {
    Game = 'Game',
    Hot = 'Hot',
    Cold = 'Cold',
}
